import { useState } from "react"
import { useAuth } from "reactfire"
import { signInWithEmailAndPassword } from "firebase/auth"
import { Link, useNavigate } from "react-router-dom"
import fondoFogata from "../assets/images/fogata2.jpg"
import logoGrupo from "../assets/images/logo-grupo.jpg"   // ← Cambia el nombre si tu archivo se llama distinto
import "../styles/auth.css"

export default function Login() {
  const auth = useAuth()
  const navigate = useNavigate()

  const [form, setForm] = useState({ email: "", password: "" })
  const [cargando, setCargando] = useState(false)
  const [error, setError] = useState("")

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(f => ({ ...f, [name]: value }))
    setError("")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!form.email || !form.password) {
      setError("Completa todos los campos.")
      return
    }

    setCargando(true)
    setError("")

    try {
      await signInWithEmailAndPassword(auth, form.email, form.password)
      navigate("/dashboard")
    } catch (err) {
      const mensajes = {
        "auth/user-not-found":  "No existe una cuenta con ese correo.",
        "auth/wrong-password":  "Contraseña incorrecta.",
        "auth/invalid-email":   "El correo no es válido.",
        "auth/too-many-requests": "Demasiados intentos. Intenta más tarde.",
        "auth/invalid-credential": "Correo o contraseña incorrectos.",
      }
      setError(mensajes[err.code] || "Error al iniciar sesión.")
    } finally {
      setCargando(false)
    }
  }

  return (
    <div className="auth-root">
      {/* Panel izquierdo decorativo - solo imagen de fondo */}
      <div 
        className="auth-panel-left"
        style={{
          backgroundImage: `url(${fondoFogata})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {/* Quitamos la flor de lis grande que estaba aquí */}
        {/* <div className="panel-flor-de-lis">⚜️</div>  ← Eliminado */}

        <div className="panel-logo">
          <img 
            src={logoGrupo} 
            alt="Logo del Grupo Scout" 
            className="panel-logo-icon-img"   // Nueva clase para estilizar la imagen
            style={{ 
              width: '90px',           // Ajusta el tamaño según necesites
              height: '90px',
              objectFit: 'contain'     // Para que no se distorsione
            }}
          />
          <span className="panel-logo-text">NSDP<br />Finanzas</span>
        </div>

        <div className="panel-quote">
          <p className="panel-quote-texto">
            "Una vez scout<br />siempre scout."
          </p>
          <p className="panel-quote-autor">Lema Scout — Siempre Mejor</p>
        </div>
      </div>

      {/* Panel derecho: formulario */}
      <div className="auth-panel-right">
        <div className="auth-form-wrapper">
          <h1 className="auth-titulo">Bienvenido</h1>
          <p className="auth-subtitulo">Ingresa a tu cuenta para continuar</p>

          {error && (
            <div className="auth-error">
              <span>⚠</span> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div className="auth-field">
              <label className="auth-label" htmlFor="email">Correo electrónico</label>
              <div className="auth-input-wrap">
                <input
                  id="email"
                  className="auth-input"
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="dirigente@scouts.cl"
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="auth-field">
              <label className="auth-label" htmlFor="password">Contraseña</label>
              <div className="auth-input-wrap">
                <input
                  id="password"
                  className="auth-input"
                  type="password"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  autoComplete="current-password"
                />
              </div>
            </div>

            <button className="auth-btn" type="submit" disabled={cargando}>
              {cargando && <span className="auth-btn-spinner" />}
              {cargando ? "Ingresando..." : "Iniciar sesión"}
            </button>
          </form>

          <p className="auth-link-text">
            ¿No tienes cuenta?
            <Link className="auth-link" to="/register">Regístrate aquí</Link>
          </p>
        </div>
      </div>
    </div>
  )
}